import { AudienceParcoursStubPage } from '../../../../components/parcours/AudienceParcoursStubPage';
import { PROCESS_AG_COPROPRIETES } from '../../../../config/process-ag-coproprietes';

export default function PptPage() {
  const item = PROCESS_AG_COPROPRIETES.find((p) => p.slug === 'ppt');
  if (!item) return null;
  return (
    <AudienceParcoursStubPage
      parcours={item}
      audienceId="coproprietes"
      segment="process-ag"
      segmentLabel="Process AG"
      ctaFinalOverride={{
        eyebrow: 'PPT · loi Climat 2021, art. 171',
        title: 'Un plan à 10 ans, taillé pour votre immeuble',
        description:
          "On dresse l\u2019état technique de votre immeuble, on hiérarchise les travaux sur dix ans et on raccorde le tout au DPE collectif et au fonds travaux ALUR. On vous met en relation avec un prestataire qualifié.",
        primary: { label: 'Cadrer mon PPT', href: '/contact?source=coproprietes&besoin=ppt' },
        secondary: { label: 'Diagnostic CEE copro', href: '/coproprietes/diagnostic-cee' },
        bullets: ['Loi Climat 2021 respectée', 'Cohérent avec votre DPE collectif', 'Alimente le fonds travaux ALUR'],
      }}
    />
  );
}
